export const queryParams = {
    reference: '',
    merchantID:''
}